import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PriceAdjust from './PriceAdjust';
import styles from './PriceAdjust.styles';
import { adjustProductPrice } from '../../../../actions';

const mapDispatchToProps = {
  adjustProductPrice,
};

export default compose(
  withStyles(styles),
  connect(
    null,
    mapDispatchToProps,
  ),
)(PriceAdjust);
